import React from "react";

interface GSTCalculatorProps {
  baseAmount: number;
  gstRate?: number; 
  className?: string;
}

interface GSTCalculation {
  subtotal: number;
  gstAmount: number;
  total: number;
  gstRate: number;
}

export const calculateGST = (baseAmount: number, gstRate: number = 18): GSTCalculation => {
  const subtotal = baseAmount;
  const gstAmount = (baseAmount * gstRate) / 100;
  const total = baseAmount + gstAmount;

  return {
    subtotal,
    gstAmount,
    total,
    gstRate,
  };
};

const GSTCalculator: React.FC<GSTCalculatorProps> = ({
  baseAmount,
  gstRate = 18,
  className = "",
}) => {
  const calculation = calculateGST(baseAmount, gstRate);

  const formatAmount = (amount: number): string => {
    return amount.toFixed(2);
  };

  return (
    <div className={`bg-[#F1FBFB] rounded-[12px] border-[0.5px] border-[#6DD0CF] px-3 py-4 space-y-3 ${className}`}>
      {/* Subtotal */}
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium text-[#202020]">Subtotal</span>
        <span className="text-[12px] 2xl:text-[14px] 4xl:text-[16px] font-semibold text-[#202020]">
          ₹{formatAmount(calculation.subtotal)}
        </span>
      </div>

      {/* GST */}
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium text-[#202020]">
          GST ({calculation.gstRate}%)
        </span>
        <span className="text-[12px] 2xl:text-[14px] 4xl:text-[16px] font-semibold text-[#007E7F]">
          ₹{formatAmount(calculation.gstAmount)}
        </span>
      </div>

      {/* Divider */}
      <hr className="border-gray-200" />

      {/* Total */}
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium text-[#202020]">Invoice total</span>
        <span className="text-[12px] 2xl:text-[14px] 4xl:text-[16px] font-semibold text-[#19213D]">
          ₹{formatAmount(calculation.total)}
        </span>
      </div>
    </div>
  );
};

export default GSTCalculator;